(() => {
  const mount = () => {
    const header = document.querySelector('[data-site-header]');
    const menu = header?.querySelector('[data-mobile-nav]');
    if (!header || !menu || menu.dataset.cleanMenuReady === 'true') return;

    menu.dataset.cleanMenuReady = 'true';
    header.classList.remove('is-mobile-liquid-nav');
    const trigger = menu.querySelector('.mobile-nav-trigger');

    const sync = () => {
      const open = menu.open && window.matchMedia('(max-width: 989px)').matches;
      document.body.classList.toggle('af-mobile-menu-open', open);
      trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const close = (restoreFocus = false) => {
      menu.open = false;
      sync();
      if (restoreFocus) trigger?.focus({ preventScroll: true });
    };

    trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      menu.open = !menu.open;
      sync();
    });

    menu.addEventListener('toggle', sync);
    menu.querySelectorAll('[data-mobile-nav-close]').forEach((button) => {
      button.addEventListener('click', () => close(true));
    });
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => close(false));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) close(true);
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) close(false);
    }, { passive: true });

    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', mount);
})();
